class SizeGauge extends HTMLElement {
  constructor() {
    super();

    const dataScript = this.querySelector('[data-size-json]');
    this.data = JSON.parse(dataScript.textContent).sort((a, b) => a.cm - b.cm);

    this.minCm = this.data[0].cm;
    this.maxCm = this.data[this.data.length - 1].cm;
    this.valueCm = this.data[Math.floor(this.data.length / 2)].cm;
    this.unit = 'cm';

    this.dial = this.querySelector('.size-gauge__dial');
    this.arc = this.querySelector('.size-gauge__arc');
    this.handle = this.querySelector('.size-gauge__handle');
    this.sizeReadout = this.querySelector('.size-gauge__size');
    this.slider = this.querySelector('.size-gauge__slider');
    this.sliderValue = this.querySelector('.size-gauge__slider-value');
    this.resultSize = this.querySelector('.size-gauge__result-size');
    this.resultStock = this.querySelector('.size-gauge__result-stock');
    this.saveButton = this.querySelector('.size-gauge__save');
    this.unitButtons = Array.from(this.querySelectorAll('.size-gauge__unit-button'));

    this.circumference = 2 * Math.PI * 86;
    this.arc.style.strokeDasharray = `${this.circumference} ${this.circumference}`;

    this.slider.min = this.minCm;
    this.slider.max = this.maxCm;
    this.slider.step = 0.1;
    this.slider.value = this.valueCm;

    this.slider.addEventListener('input', () => this.setValue(parseFloat(this.slider.value)));
    this.dial.addEventListener('pointerdown', this.onDialDown.bind(this));

    this.unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.unit = button.dataset.unit;
        this.unitButtons.forEach((b) => b.classList.toggle('size-gauge__unit-button--active', b === button));
        this.render();
      });
    });

    this.saveButton.addEventListener('click', () => {
      const nearest = this.nearestSize();
      localStorage.setItem('firecapsFittedSize', JSON.stringify({ size: nearest.size, cm: this.valueCm }));
      this.saveButton.textContent = 'Saved';
      setTimeout(() => {
        this.saveButton.textContent = 'Save my size';
      }, 1500);
    });

    this.render();
  }

  onDialDown(event) {
    const move = (moveEvent) => this.setValueFromPointer(moveEvent);
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    this.setValueFromPointer(event);
  }

  setValueFromPointer(event) {
    const rect = this.dial.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = event.clientX - cx;
    const dy = event.clientY - cy;
    let angle = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
    if (angle < 0) angle += 360;
    const percent = angle / 360;
    this.setValue(this.minCm + percent * (this.maxCm - this.minCm));
  }

  setValue(cm) {
    this.valueCm = Math.min(this.maxCm, Math.max(this.minCm, cm));
    this.slider.value = this.valueCm;
    this.render();
  }

  nearestSize() {
    return this.data.reduce((closest, entry) =>
      Math.abs(entry.cm - this.valueCm) < Math.abs(closest.cm - this.valueCm) ? entry : closest
    );
  }

  formatValue(cm) {
    if (this.unit === 'in') return `${(cm / 2.54).toFixed(2)} in`;
    return `${cm.toFixed(1)} cm`;
  }

  render() {
    const percent = (this.valueCm - this.minCm) / (this.maxCm - this.minCm);
    this.arc.style.strokeDashoffset = `${this.circumference * (1 - percent)}`;

    const angleRad = percent * 2 * Math.PI - Math.PI / 2;
    const handleX = 100 + 86 * Math.cos(angleRad);
    const handleY = 100 + 86 * Math.sin(angleRad);
    this.handle.setAttribute('cx', handleX);
    this.handle.setAttribute('cy', handleY);

    const nearest = this.nearestSize();
    this.sizeReadout.textContent = nearest.size;
    this.resultSize.textContent = nearest.size;
    this.resultStock.textContent = `${nearest.total} pieces across ${nearest.styles} styles`;
    this.sliderValue.textContent = this.formatValue(this.valueCm);
  }
}

customElements.define('size-gauge', SizeGauge);
